import FormMixin from '@/mixins/formvalid'
import gInput from '@/components/googlemaps/gInput';

export default {
  mixins: [FormMixin],
  props: ['dialog', 'form', 'destination'],
  components: {
    'g-input': gInput
  },
  data () {
    return {
      valid: false,
      adress_notValid: false,
      menu: false,
      menu2: false,
      time: null,
      date: null,
      dateFormatted: null,
      items: []
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.form.address && this.form.zip && this.form.city) {
          console.log('destination', this.form);
          this.$emit('save', this.form);
        } else {
          this.adress_notValid = true;
          console.log('check your address');
        }
      }
    },
    close () {
      this.$emit('close');
    },
    setAddress (v) {
      this.form.fullAddress = v;
    },
    setPlace (v) {
      if (v.street_number && v.postal_code && v.route && v.locality) {
        this.form.address = v.route + ' ' + v.street_number;
        this.form.zip = v.postal_code;
        this.form.city = v.locality || '';
        this.form.latitude = v.latitude;
        this.form.longitude = v.longitude;
        this.adress_notValid = false;
      } else {
        this.adress_notValid = true;
        this.form.fullAddress = this.form.address = this.form.zip = this.form.city = null;
      }
      console.log(v);
    },
    prefill (d) {
      for (var key in d) {
        this.form[key] = d[key]; // copies each property to the form object
      }
      this.adress_notValid = false;
      console.log(d.fullAddress, this.$refs.address);

      if (d.fullAddress) {
        this.$nextTick(() => { this.$refs.address_dest.update(d.fullAddress); });
      }
    },
    init (v) {
      if (v) {
        console.log('Edit: do init:', this.destination);
        this.prefill(this.destination);
      }
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  }
}
